import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  content: {
    width: 450,
    maxWidth: 450,
    maxHeight: 600,
    overflow: 'auto',
    ...theme.scrollbarStyles
  },
  mainPaper: {
    flex: 1,
    maxHeight: 300,
    maxWidth: 500,
    padding: theme.spacing(1),
    overflowY: 'scroll',
    ...theme.scrollbarStyles
  },

  listAnnoucements: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '0px'
  },

  listItemAnnoucements: {
    maxWidth: 315,
    minWidth: 315,
    backgroundColor:theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.gray_50.main,
    borderRadius: '8px',
    // cursor: 'pointer'
    '&:hover': {
      backgroundColor:theme.palette.type === 'dark' ? theme.palette.dark_700.main : theme.palette.blue_50.main
    }
  },

  listItemAnnoucementsTitle: {
    display: 'flex',
    gap: '8px',
    color: theme.palette.blue_300.main,
    fontWeight: '500',
    cursor: 'pointer',
    '& svg': {
      color: theme.palette.blue_300.main
    }
  },

  listItemAnnoucementsDate: {
    color: theme.palette.gray_400.main,
    display: 'flex',
    fontSize: '0.75rem',
    justifyContent: 'flex-end',
    marginTop: '8px'
  },

  listItemAnnoucementsText: {
    display: '-webkit-box', // Altera para usar display box
    marginLeft: '34px',
    color:theme.palette.type === 'dark' ? theme.palette.dark_50.main : theme.palette.gray_400.main,
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '350px',
    maxHeight: '40px', // Define altura máxima (ajuste conforme necessário)
    '-webkit-line-clamp': 2, // Número de linhas antes de adicionar ellipsis
    '-webkit-box-orient': 'vertical',
    '& a': {
      color: theme.palette.blue_300.main,
      textDecoration: 'none'
    },
    '& a:hover': {
      textDecoration: 'underline'
    }
  }
}))
